import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { token } from "@/styled-system/tokens";
import { Card } from "@zillow/constellation-10";
import React from "react";
import { migrateColorToken, migrateSpacingToken } from "../../utils/token-migration/v8-to-v10.esm.js";
function resolveValue(value) {
  if (!value) return void 0;
  if (typeof value === "string") return value;
  return value.default ?? Object.values(value)[0];
}
function resolveSpacingVar(value) {
  if (value === void 0 || value === null) return void 0;
  const raw = typeof value === "string" ? value : value.default ?? Object.values(value)[0];
  if (!raw) return "0";
  const v10 = migrateSpacingToken(raw) ?? raw;
  return token.var(`spacing.${v10}`);
}
function resolveColorVar(value) {
  if (!value) return void 0;
  const v10 = migrateColorToken(value) ?? value;
  return token.var(`colors.${v10}`);
}
const cardLayoutStyles = css.raw({
  display: "flex",
  flexDirection: "column"
});
const ColorCard = React.forwardRef(({
  backgroundColor,
  fontColor,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  style,
  className,
  children,
  css: cssProp,
  ...rest
}, ref) => {
  const bgVar = resolveColorVar(resolveValue(backgroundColor));
  const fgVar = resolveColorVar(resolveValue(fontColor));
  const ptVar = resolveSpacingVar(paddingTop);
  const prVar = resolveSpacingVar(paddingRight);
  const pbVar = resolveSpacingVar(paddingBottom);
  const plVar = resolveSpacingVar(paddingLeft);
  const cssVars = {};
  if (ptVar) {
    cssVars["--_cimg-mt"] = `calc(-1 * ${ptVar})`;
    cssVars["--_cimg-mb"] = ptVar;
  }
  if (prVar) cssVars["--_cimg-mr"] = `calc(-1 * ${prVar})`;
  if (plVar) cssVars["--_cimg-ml"] = `calc(-1 * ${plVar})`;
  const mergedStyle = {
    ...bgVar ? {
      backgroundColor: bgVar
    } : {},
    ...fgVar ? {
      color: fgVar
    } : {},
    ...ptVar ? {
      paddingTop: ptVar
    } : {},
    ...prVar ? {
      paddingRight: prVar
    } : {},
    ...pbVar ? {
      paddingBottom: pbVar
    } : {},
    ...plVar ? {
      paddingLeft: plVar
    } : {},
    ...cssVars,
    ...style
  };
  return /* @__PURE__ */ jsx(Card, { ref, "data-zrs-color-card": true, className, style: mergedStyle, ...rest, css: css.raw(cardLayoutStyles, cssProp), children });
});
ColorCard.displayName = "ColorCard";
export {
  ColorCard as default
};
